export default "__VITE_ASSET__C5hFP02u__"